
import { defineComponent, ref, computed } from 'vue'
import JrFileInput from '@/components/jr-parts/JrFileInput.vue'
import { MESSAGE_TYPE_TOAST, addMessageQueue } from '@/plugins/messageQueue'
import MessageService from '@/services/message'
import { FileTypes, FileTypeNames, APPLICANT_UPLOAD_FILE_EXTS, JR_UPLOAD_FILE_EXTS } from '@/constants/enums'
import { CreateRequest } from '@/requests/proximityFile'
import { ProximityFile } from '@/api'

/**
 * 添付ファイル選択コンポーネント
 */
export default defineComponent({
  name: 'UploadProximityFile',
  emits: ['update:modelValue', 'uploaded'],
  components: {
    JrFileInput,
  },
  props: {
    // ファイルID
    modelValue: {
      type: Number,
      required: false,
      default: null,
    },
    applicant: {
      type: Boolean,
      required: false,
      default: false,
    },
    // ファイル種別
    fileType: {
      type: Number,
      required: true,
    },
    // 近接工事詳細ID
    proximityId: {
      type: Number,
      required: true,
    },
  },
  setup(props, context) {
    const allowExts = computed(() => {
      return props.applicant ? APPLICANT_UPLOAD_FILE_EXTS : JR_UPLOAD_FILE_EXTS
    })

    // ファイルref
    let fileInputRef = ref<InstanceType<typeof JrFileInput>>()

    const change = async (fileId: number | null) => {
      let columnName: string

      // DBの更新するカラムをファイル種別から判定
      if (FileTypes.PROXIMITY_DISCUSSION_DOCUMENT === props.fileType) {
        // 近接工事-協議書
        columnName = 'discussion_document_file'
      } else if (FileTypes.PROXIMITY_ANSWER_DRAFT === props.fileType) {
        // 近接工事-回答案
        columnName = 'answer_draft_file'
      } else if (FileTypes.PROXIMITY_ANSWER === props.fileType) {
        // 近接工事-回答
        columnName = 'answer_file'
      } else if (FileTypes.PROXIMITY_ANSWER_CONFIRMATION === props.fileType) {
        // 近接工事-回答請書
        columnName = 'answer_confirmation_file'
      } else if (FileTypes.PROXIMITY_ADVERSARIA === props.fileType) {
        // 近接工事-覚書
        columnName = 'adversaria_file'
      } else {
        throw new Error('Invalid arguments for fileType: ' + props.fileType)
      }

      const fileInfo: ProximityFile = {
        [columnName]: fileId,
      }

      // requestの作成
      const request = new CreateRequest(props.proximityId, fileInfo)
      // API実行
      await request.exec()

      // API成功
      if (request.success) {
        addMessageQueue(
          MESSAGE_TYPE_TOAST,
          MessageService.bind(MessageService.codes.CHANGE_COMPLETE, { target: FileTypeNames[props.fileType] })
        )
        context.emit('uploaded')
      }
    }

    return {
      fileInputRef,
      allowExts,
      update: (event: string) => {
        context.emit('update:modelValue', event)
      },
      change,
    }
  },
})
